import React from "react";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";

const QuantitySelector = ({ quantity, setQuantity }) => {
  const increment = () => setQuantity((prev) => Math.min(prev + 1, 150));
  const decrement = () => setQuantity((prev) => Math.max(prev - 1, 1));

  return (
    <div className="flex items-center gap-4">
      <button onClick={decrement}>
        <FiMinusCircle className="text-2xl text-orange-500 hover:text-orange-600 transition duration-200" />
      </button>
      <span className="text-xl font-semibold">{quantity}</span>
      <button onClick={increment}>
        <FiPlusCircle className="text-2xl text-orange-500 hover:text-orange-600 transition duration-200" />
      </button>
    </div>
  );
};

export default QuantitySelector;
